import generateTypes from '../utils/generateTypes';

export const GET_MODERATIONS = generateTypes('GET_MODERATIONS');
export const RESET_MODERATIONS = 'RESET_MODERATIONS';
